import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/$programId')({
  beforeLoad: ({ context, params }) => {
    const { auth } = context;

    const { allowedProductions } = auth;

    const hasProduction = allowedProductions.some((production) => {
      return production.code === params.programId;
    });

    if (!hasProduction) {
      throw redirect({ to: '/forbidden' });
    }
  },
  onEnter: ({ context, params }) => {
    const { auth } = context;

    const { selectProduct } = auth;

    if (
      Number(params.programId) &&
      auth.allowedProductions.find((production) => production.code === params.programId)
    ) {
      selectProduct(params.programId);
    }
  },
});
